import { useEffect, useMemo } from 'react';
import { Text } from '~/commonComponents/Text';
import ConfirmPopup from '~/components/shared/ConfirmPopup';
import { BestInDentalStatus } from '~/enums/BestInDental';
import { useAppSelector, useToggle, useUserSelector } from '~/hooks';
import BestInDentalBadge from '~/images/best-in-dental-professional.png';
import { IMultipleCounters } from '~/models';
import { Colors } from '~/themes/colors';
import { getProfessionalBestInDentalStorageKey } from './Constants';

interface IProps {
  candidateId: string;
}

export const BestInDentalProfessionalPopup = ({ candidateId }: IProps) => {
  const [isOpen, controls] = useToggle();

  const candidates: IMultipleCounters[] = useAppSelector((state) => state?.job?.allCandidates);
  const currentUser = useUserSelector();

  const isBestInDentalWinners = useMemo(() => {
    return (
      (candidates || []).find((it) => it.candidate.id === candidateId)?.candidate?.professional_info
        ?.bestInDental?.status === BestInDentalStatus.Winner
    );
  }, [candidateId, candidates]);

  useEffect(() => {
    if (!currentUser) return;

    const key = getProfessionalBestInDentalStorageKey(currentUser.id);

    const result = localStorage.getItem(key);

    if (result === 'true' || !isBestInDentalWinners) {
      controls.setOff();
      return;
    }

    controls.setOn();
  }, [controls, currentUser, isBestInDentalWinners]);

  if (!isOpen) {
    return null;
  }

  return (
    // @ts-expect-error - ConfirmPopup still written in JavaScript
    <ConfirmPopup
      modalStyle={{ maxWidth: 500, maxHeight: 500, paddingTop: 57 }}
      Icon={() => (
        <img alt="Best In Dental Badge" src={BestInDentalBadge} width={164} height={184} />
      )}
      title="GoTu Best in Dental Winner"
      titleStyle={{ marginBlock: 16 }}
      description={
        <Text color={Colors.neutral_500}>
          This badge means the professional is nationally recognized
          <br />
          for delivering excellent patient care, supporting strong office
          <br />
          culture, and consistently showing up for the teams they
          <br />
          work with. It’s GoTu’s highest honor for reliability and
          <br />
          professionalism.
        </Text>
      }
      descriptionStyle={{ marginBottom: 24, width: '100%' }}
      rightButtonText="Got It"
      rightButtonAction={() => {
        controls.setOff();
        localStorage.setItem(getProfessionalBestInDentalStorageKey(currentUser.id), 'true');
      }}
    />
  );
};
